import React from 'react'
import TextField from '@material-ui/core/TextField'

const CustomInput = (props) => {
    const shrink = props.shrink ? props.shrink.toString() : 'false'
    return (
        <div className="customInput">
            <TextField
                defaultValue={props.defaultValue}
                value={props.value}
                autoFocus={props.autoFocus}
                name={props.name}
                onChange={props.onChange || props.onChange}
                onBlur={props.onBlur || props.onBlur}
                onKeyDown={props.onKeyDown || props.onKeyDown}
                InputProps={{
                    inputProps: props.inputProps,
                    startAdornment: props.startadornment,
                    endAdornment: props.endadornment,
                    shrink: shrink,
                }}
                id={props.id}
                label={props.label}
                type={props.type}
                size={props.size}
                disabled={props.disabled}
                variant={`${props.variant || 'outlined'}`}
                placeholder={props.placeholder}
                error={props.error}
                helperText={props.helperText}
                {...props}
            />
        </div>
    )
}

export default CustomInput
